import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { LoadingScreen } from '@/components/ui/LoadingScreen';

interface PlatformProtectedRouteProps {
  children: React.ReactNode;
}

/** Mirrors ProtectedRoute.tsx, gated on platformAdmin instead of member — a
 * regular org member hitting /platform/* directly is sent to /dashboard,
 * never shown any cross-organisation data. */
export function PlatformProtectedRoute({ children }: PlatformProtectedRouteProps) {
  const { isAuthenticated, isLoading, platformAdmin } = useAuthStore();
  const location = useLocation();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!platformAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
